import { Button } from 'react-bootstrap';
import {
  buildSeoAdviceChatUrl,
  type SeoAdviceSnapshot,
} from '../lib/seo-ai-prompt';
import { ActionTip } from './ActionTip';

const TIP = 'تحلیل مشکل ایندکس با ChatGPT';

/** Official OpenAI / ChatGPT mark (filled via currentColor). */
export function ChatGptIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      fill="currentColor"
      aria-hidden
      focusable="false"
    >
      <path d="M22.282 9.821a5.985 5.985 0 0 0-.516-4.911 6.046 6.046 0 0 0-6.51-2.9A6.065 6.065 0 0 0 4.981 4.182a5.985 5.985 0 0 0-3.998 2.9 6.046 6.046 0 0 0 .743 7.097 5.98 5.98 0 0 0 .51 4.911 6.051 6.051 0 0 0 6.515 2.9A5.985 5.985 0 0 0 13.26 24a6.056 6.056 0 0 0 5.772-4.206 5.99 5.99 0 0 0 3.998-2.9 6.056 6.056 0 0 0-.748-7.073zm-9.022 12.608a4.476 4.476 0 0 1-2.876-1.04l.142-.08 4.778-2.758a.795.795 0 0 0 .393-.681v-6.737l2.02 1.168a.071.071 0 0 1 .038.052v5.583a4.504 4.504 0 0 1-4.495 4.494zM3.6 18.304a4.471 4.471 0 0 1-.535-3.014l.142.085 4.783 2.758a.771.771 0 0 0 .78 0l5.843-3.369v2.333a.08.08 0 0 1-.033.062L9.74 19.95a4.499 4.499 0 0 1-6.14-1.646zM2.34 7.896a4.485 4.485 0 0 1 2.366-1.973v5.677a.766.766 0 0 0 .388.677l5.815 3.354-2.02 1.169a.076.076 0 0 1-.071 0l-4.83-2.787A4.504 4.504 0 0 1 2.34 7.872zm16.597 3.855-5.833-3.387L15.119 7.2a.076.076 0 0 1 .071 0l4.83 2.791a4.494 4.494 0 0 1-.676 8.105v-5.678a.79.79 0 0 0-.407-.667zm2.01-3.023-.141-.085-4.774-2.782a.776.776 0 0 0-.785 0L9.409 9.23V6.897a.066.066 0 0 1 .028-.061l4.83-2.787a4.499 4.499 0 0 1 6.68 4.66zM8.307 12.863l-2.02-1.164a.08.08 0 0 1-.038-.057V6.074a4.499 4.499 0 0 1 7.376-3.454l-.142.08-4.778 2.759a.795.795 0 0 0-.393.681zm1.097-2.365 2.602-1.5 2.607 1.5v2.999l-2.597 1.5-2.607-1.5z" />
    </svg>
  );
}

/** Opens ChatGPT with a senior-SEO prompt plus this URL's Search Console history. */
export function SeoAiAdviceAction({
  url,
  snapshots,
  disabled = false,
}: {
  url: string;
  snapshots: SeoAdviceSnapshot[];
  disabled?: boolean;
}) {
  const tip = disabled
    ? 'صفحه ایندکس‌شده است؛ تحلیل مشکل لازم نیست'
    : TIP;

  return (
    <ActionTip tip={tip}>
      <span className="d-inline-flex">
        <Button
          size="sm"
          variant="outline-secondary"
          className={
            disabled
              ? 'if-table-action seo-ai-action seo-ai-action--disabled'
              : 'if-table-action seo-ai-action'
          }
          aria-label={tip}
          disabled={disabled}
          href={disabled ? undefined : buildSeoAdviceChatUrl(url, snapshots)}
          target={disabled ? undefined : '_blank'}
          rel={disabled ? undefined : 'noreferrer'}
        >
          <ChatGptIcon />
        </Button>
      </span>
    </ActionTip>
  );
}

/** Inline footer link variant used inside the index-history timeline. */
export function SeoAiAdviceLink({
  url,
  snapshots,
  disabled = false,
}: {
  url: string;
  snapshots: SeoAdviceSnapshot[];
  disabled?: boolean;
}) {
  const tip = disabled
    ? 'صفحه ایندکس‌شده است؛ تحلیل مشکل لازم نیست'
    : TIP;

  if (disabled) {
    return (
      <span
        className="seo-ai-link seo-ai-link--disabled"
        aria-disabled="true"
        title={tip}
      >
        <ChatGptIcon className="seo-ai-link-icon" />
        <span>{TIP}</span>
      </span>
    );
  }

  return (
    <a
      className="seo-ai-link"
      href={buildSeoAdviceChatUrl(url, snapshots)}
      target="_blank"
      rel="noreferrer"
    >
      <ChatGptIcon className="seo-ai-link-icon" />
      <span>{TIP}</span>
    </a>
  );
}
